function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "6.49 25.5 21.51 24.5 17.48 20.5 25.51 12.49 19.48 6.5 11.49 14.49 7.49 10.5 6.49 25.5",
    style: {
      fill: "#6eb005"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceived);
export default __webpack_public_path__ + "static/media/received.e8dc6818.svg";
export { ForwardRef as ReactComponent };